import { useNavigate } from 'react-router-dom'
import { Button } from '@dashboard/ui'
import { PageHeader, Table, TableCell, TableRow, TableRowSkeleton } from '@/ui'

import { useTranslation } from 'react-i18next'
import { useCurrentUser } from '@/api/useCurrentUser'
import { PROGRESSIVE_PROGRAM_PATH_FORM, useGenerateCompanyPath } from '@/libs'
import { TableZeroStateFilter } from '@/layouts/components/TableZeroStateFilter'
import { DEFAULT_LOAD_LIMIT } from '@/api/useGameItems'
import { useProgressionProgramsQuery } from '@/layouts/progression-program/api/useProgressionProgramsQuery'
import { URL_NEW } from '@/types'
import { ProgressionTableRow } from '@/layouts/progression-program/widgets/ProgressionTableRow'

export const ProgressionProgramPage = () => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { canEdit } = useCurrentUser()
  const { generatePath } = useGenerateCompanyPath()

  const { data: items = [], isLoading } = useProgressionProgramsQuery(companyId, gameId, {
    limit: DEFAULT_LOAD_LIMIT,
  })

  const openEditForm = (id: string) => {
    navigate(generatePath(PROGRESSIVE_PROGRAM_PATH_FORM, { programId: id }, true))
  }

  const renderDefaultHeader = () => {
    return (
      <TableRow variant="header">
        <TableCell width="100%">{t('name')}</TableCell>
        <TableCell width={200}>{t('item')}</TableCell>
        <TableCell width={160}>{t('datetime.start_at')}</TableCell>
        <TableCell width={160}>{t('datetime.end_at')}</TableCell>

        <TableCell width={80} />
      </TableRow>
    )
  }

  const renderZeroState = () => {
    return (
      <TableZeroStateFilter
        hasFilter={false}
        page={1}
        items={items}
        createClick={() => {
          openEditForm(URL_NEW)
        }}
        zeroStateMessage={t('progression.zero.title')}
        zeroStateSubMessage={t('progression.zero.message')}
        addButtonText={t('progression.create')}
        clearFilterClick={() => {}}
      />
    )
  }

  return (
    <div className="flex h-full flex-col">
      <PageHeader
        extra={
          canEdit && (
            <>
              {!!items.length && (
                <Button size="sm" onClick={() => openEditForm(URL_NEW)}>
                  {t('progression.create')}
                </Button>
              )}
            </>
          )
        }
      >
        {t('sidebar.progression-programs')}
      </PageHeader>

      {isLoading ? (
        <TableRowSkeleton rowCount={10} columnCount={5} />
      ) : items.length === 0 ? (
        renderZeroState()
      ) : (
        <>
          <Table>
            {renderDefaultHeader()}
            {items.map(it => (
              <ProgressionTableRow program={it} key={it.id} />
            ))}
          </Table>
        </>
      )}
    </div>
  )
}
